// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".78f24056a74c0cca00146d384d887477f9bcb63e.chunk.js";
};